// extracted by mini-css-extract-plugin
module.exports = {"CustomTooltip":"CustomTooltip_CustomTooltip__LRYEP","Blue":"CustomTooltip_Blue__Zo5Us","Red":"CustomTooltip_Red__Y1Cr6","RightPos":"CustomTooltip_RightPos__UjW80"};